import { CurrentDot, ProgressDot } from "components/ProgressDot";
import { ProgressDotsProps } from "interfaces/ProgressDotsProps.interface";
import React from "react";
import { ProgressDotContainerStyle } from "styles/ProgressDotContainer.style";

export default function ProgressDots({
    dotCount,
    currentIndex
}: ProgressDotsProps): React.JSX.Element {
    let dots: React.JSX.Element[] = [];
    for (let i = 0; i < dotCount; i++) dots.push(i == currentIndex ? CurrentDot() : ProgressDot());

    return (
        <div id='DotContainer' style={ProgressDotContainerStyle}>
            {
                dots
            }
        </div>
    );
};
